import { ReactEditor } from '@lumapps/wrex/slate';

import { TableEditor, TableToolbarButtons } from '../types';
import { getCurrentSelectionInfos } from './getCurrentSelectionInfos';

export const getActiveTableButtons = (editor: ReactEditor & TableEditor) => {
    const activeButtons: TableToolbarButtons[] = [
        'toggle-header-row',
        'add-row-before',
        'add-row-after',
        'add-column-before',
        'add-column-after',
    ];

    const selectionInfos = getCurrentSelectionInfos(editor);
    if (!selectionInfos) {
        return { activeButtons: [] as TableToolbarButtons[] };
    }

    const {
        isSelectionInOneCell,
        oneRowFullySelected,
        oneColFullySelected,
        allTableSelected,
        selectedRows,
        selectedCols,
        tablePath,
    } = selectionInfos;

    if (isSelectionInOneCell) {
        activeButtons.push('delete-row', 'delete-column', 'delete-table');
        return { activeButtons, tablePath };
    }

    if (oneRowFullySelected) {
        activeButtons.push('delete-row');
        return { activeButtons, tablePath };
    }
    if (oneColFullySelected) {
        activeButtons.push('delete-column');
        return { activeButtons, tablePath };
    }
    if (allTableSelected) {
        activeButtons.push('delete-table');
        return { activeButtons, tablePath };
    }
    activeButtons.push('delete-column', 'delete-row');
    return { activeButtons, selectedRows, selectedCols, tablePath };
};
